import React from "react";
import { useSelector } from "react-redux";
import StakeholderDetails from "components/CompanyDashboard/BusinessDetails/StakeholderDetails";

const CompanyOfficial = () => {
  // Redux state
  // const companyOfficialsSlice = useSelector(
  //   (state) => state.companyOfficialsSlice
  // );
  const { company } = useSelector((state) => state.companySlice);

  const companyId = company?._id;

  const isInchangesModule = true;
  return (
    <div className="relative">
      <StakeholderDetails
        isInchangesModule={isInchangesModule}
        companyId={companyId}
      />
    </div>
  );
};

export default CompanyOfficial;
